import {useRef,useMemo,useCallback} from "react";
import COMPONENT_MAP from '../Repository/Components.js';
import DataManagementDetailLocalesPopup from './DataManagementDetailLocalesPopup.js';
import {useSnackbar} from '../SnackbarContext.js';
import {useLoading} from '../LoadingContext';
import {refreshServerVariable} from '../../../core/integration/Api.js';

const DataManagementDetailLocales=({userData,application})=>{
    const list_name='locales';
    const executeQuery=useRef(true);
    const {showSnackbar}=useSnackbar();
    const {showLoading,hideLoading}=useLoading();

    const refreshServerVariableCall=useCallback((api)=>{
        showLoading();
        refreshServerVariable(api).then((data)=>{
            if('error' in data){
                showSnackbar(data.error,'error');
            } 
            else{
                showSnackbar(data.message,'success');
            }
            hideLoading();
        });
    },[showLoading,hideLoading,showSnackbar]);

    const pageCallback=useCallback(async(action,args)=>{
        if(action==='invoke_method'){
            if(args.args.method_name==='refresh-locales'){
                refreshServerVariableCall(args.args.method_name);
            }
        }
    },[refreshServerVariableCall]);

    const renderListTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ListTab'];
        return Component?(
            <Component
                parentId={'null'}
                parentContext={{}}
                application={application}
                userData={userData}
                entityType={'Locales'}
                entityParams={['_lang='+application.globalData.lang]}
                list_name={list_name}
                height={window.innerHeight-170}
                file={'DataManagementDetailLocales.js'}
                initialState={{}}
                checkboxSelection={true}
                disableRowSelectionOnClick={true}
                disableSelectionOnClick={true}
                popupComponent={DataManagementDetailLocalesPopup}
                focusOnSearchInput={true}
                navigateOnNew={null}
                filterComponent={null}
                pageCallback={pageCallback}
                executeQuery={executeQuery}
                button_actions={[
                    {name:'invoke_method',label:'ButtonClearCacheLocales',args:{method_name:'refresh-locales'}},
                ]}
            />
        ):null; 
    },[application,pageCallback,userData]);

    return(renderListTab);
}

export default DataManagementDetailLocales;
